import { all, call, put, race, select, take, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import config from '../../../../../../../../../../../config'
import { LOAD_REALESTATES_ESTATES_DISTRIBUTION_DATA_TABLE, DATA_TABLE_REQUEST } from './constants'
import { BLOCK_DATA_LOADED } from '../../../../../../../../../components/Workspace/components/HocBlock/constants'

import { loadDataTableRequest } from './actions'
import { blockSaveCustomData } from '../../../../../../../../../components/Workspace/components/HocBlock/actions'

import { localeSelector, tokenSelector, customDataSelector } from './selectors'

const MODULE_KEY = config.modules.report.key
const BLOCK_KEY = config.modules.report.blocks.estates.key

function* loadDataTable(id, sorting = []) {
    const token = yield select(tokenSelector, id)
    if (!token) return null

    let customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            distribution: {
                ..._.get(customData, 'distribution', {}),
                isLoading: true,
            },
        })
    )

    const locale = yield select(localeSelector)
    const sortQsParam = _.join(
        _.map(sorting, (sort) => `${sort.id}:${sort.desc ? 'desc' : 'asc'}`),
        ','
    )

    const result = yield all({
        response: race({
            success: take(`${DATA_TABLE_REQUEST(MODULE_KEY, id, BLOCK_KEY)}_${SUCCESS}`),
            failed: take(`${DATA_TABLE_REQUEST(MODULE_KEY, id, BLOCK_KEY)}_${FAILED}`),
        }),
        request: put(
            loadDataTableRequest(MODULE_KEY, id, BLOCK_KEY, {
                lang: locale,
                'sort[]': sortQsParam,
                token,
            })
        ),
    })

    const data = _.get(result, 'response.success.payload.response.body', null)
    if (result.response.failed || !data) return null

    customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            distribution: {
                ..._.get(customData, 'distribution', {}),
                isLoading: false,
                isLoaded: true,
                table: {
                    data: _.get(data, 'rows', []),
                    sort: {
                        availableColumns: _.get(data, 'query.sort.availableColumns', []),
                        sorted: _.map(_.get(data, 'query.sort.sortedColumns', []), (sort) => ({
                            id: sort.columm,
                            desc: sort.direction === 'desc',
                        })),
                    },
                },
            },
        })
    )

    return null
}

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== BLOCK_KEY) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)

    if (!module || !id || !blockKey) return null

    const defaultSorting = [
        { id: 'restrictions', desc: true },
        { id: 'total', desc: true },
        { id: 'regionName', desc: false },
    ]
    yield call(loadDataTable, id, defaultSorting)

    return null
}

function* onLoadDataTable(_action) {
    const id = _.get(_action, 'data.id', null)
    if (!id) return null

    const sorting = _.get(_action, 'data.sorting', [])

    yield call(loadDataTable, id, sorting)

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeEvery(LOAD_REALESTATES_ESTATES_DISTRIBUTION_DATA_TABLE, onLoadDataTable),
    ])
}
